<template>
    <div id="slider">
        <transition-group tag="div" :name="transitionName" class="slides-group">
            <div class="slide" v-for="(slide, index) in slides" :key="index"
                :style="[currentSlide === index ? 'opacity: 1' : 'opacity: 0']">
                <slide :template="slide.template" :theme="slide.theme" :title="slide.title" :text="slide.text"
                    :medias="slide.medias" />
            </div>
        </transition-group>

        <div v-if="updating" class="updating-slides">
            <div v-if="slideLoadedMediaCount <= 0">
                <span class="spinner"></span> Updating content
            </div>
            <div v-else>
                <span class="spinner"></span> Updating content • Media {{ slideLoadedMediaCount }} / {{ slidesMediaCount }}
            </div>
        </div>

        <div v-if="updatingSlidesError" class="updating-slides-error">
            ⚠ TV connection issue, please check the network
        </div>
    </div>
</template>
<script lang="js">
import { ref } from 'vue'
import { mapActions, mapState } from 'vuex'
import slide from '../components/Slide.vue'
export default {

    name: 'MuralView',

    components: {
        slide
    },

    computed: {
        ...mapState(['slides', 'device', 'loadedToken', 'loadedDevice', 'loadedSlidesData', 'loadedSlidesMedia', 'slidesMediaCount', 'slideLoadedMediaCount', 'updatingSlides', 'updatingSlidesError', 'updatingSlidesErrorCount']),
        slidesLength() {
            return this.slides.length
        }
    },

    methods: {

        ...mapActions(['authenticateDevice', 'loadCurrentWeather', 'loadSlides', 'loadSlidesMedia', 'sendConnectionRefresh']),

        next() {

            try {
                this.transitionName = 'slide-next'

                // let currentSlideCalc = (this.currentSlide + this.direction % this.slidesLength + this.slidesLength) % this.slidesLength
                this.currentSlide = (this.currentSlide + this.direction % this.slidesLength + this.slidesLength) % this.slidesLength
                this.$store.commit('currentSlide', this.currentSlide)

                if (this.currentSlide === this.slidesLength - 1 && !this.updatingSlides) {
                    this.$store.commit('updatingSlides', true)
                    this.reload()
                }

            } catch (error) {
                console.error(error)

                setTimeout(() => {
                    window.location.href = 'https://collab-tv.com/#/?code=' + this.device.code
                }, 16000)

                this.$store.commit('registerError', error)
            }
        },

        async reload() {
            console.log('Updating content...')
            this.updating = true
            this.$store.commit('updatingSlides', true)
            this.$store.commit('updatingSlidesError', false)
            try {
                await this.authenticateDevice(this.device.code.toUpperCase())
                await this.loadSlides()

                if (this.slidesLength <= 0) {
                    return this.$router.push({ name: 'wait' })
                }

                console.log('Content successfully updated')
                this.$store.commit('lastContentUpdate', new Date())
                this.$store.commit('updatingSlidesError', false)
                this.$store.commit('updatingSlidesErrorCount', 0)

                this.$store.commit('lastErrorMessage', '')
                this.$store.commit('lastErrorMessageTime', '')
            } catch (error) {
                console.log('Error trying to update')
                this.$store.commit('updatingSlides', false)
                this.$store.commit('updatingSlidesError', true)
                this.$store.commit('updatingSlidesErrorCountAdd', 1)

                if (this.updatingSlidesErrorCount >= 5) {
                    window.location.href = 'https://collab-tv.com/#/?code=' + this.device.code
                }

                this.$store.commit('registerError', error)
            } finally {
                this.updating = false
                this.$store.commit('updatingSlides', false)
                if (this.currentSlide >= this.slidesLength) {
                    this.next()
                }
            }
        },

        async sendConnection() {
            console.log('Sending connection status...')
            try {
                await this.sendConnectionRefresh()
                console.log('Connection status sent')
            } catch (error) {
                this.$store.commit('registerError', error)
            }
        }
    },

    beforeUnmount() {
        if (this.interval) {
            console.log('Carousel interval cleared')
            clearInterval(this.interval)
        }

        if (this.weatherInterval) {
            console.log('Weather intercal cleared')
            clearInterval(this.weatherInterval)
        }

        if (this.connectionInterval) {
            console.log('Connection interval cleared')
            clearInterval(this.connectionInterval)
        }
    },

    mounted() {
        this.show = true
        try {
            this.sendConnection()
        } catch (error) {
            this.$store.commit('registerError', error)
        }

        try {
            this.interval = setInterval(() => {
                try {
                    this.next()
                } catch (error) {
                    this.$store.commit('registerError', error)
                }
            }, 30000)

            this.weatherInterval = setInterval(() => {
                try {
                    this.loadCurrentWeather()
                } catch (error) {
                    this.$store.commit('registerError', error)
                }
            }, 20 * 60000)

            this.connectionInterval = setInterval(() => {
                try {
                    this.sendConnection()
                } catch (error) {
                    this.$store.commit('registerError', error)
                }
            }, 30000)   
        } catch (error) {
            this.$store.commit('registerError', error)
        }

    },

    created() {
        if (!this.loadedToken && !this.loadedDevice && !this.loadedSlidesData && !this.loadedSlidesMedia) {
            this.$router.push({ name: 'home' })
        }
    },

    setup() {
        let transitionName = ref('fade')
        let direction = ref(1)
        let currentSlide = ref(0)
        let show = ref(false)
        let interval = ref(null)
        let weatherInterval = ref(null)
        let connectionInterval = ref(null)

        let updating = ref(false)

        return {
            transitionName,
            direction,
            currentSlide,
            show,
            interval,
            weatherInterval,
            connectionInterval,
            updating
        }
    }
}
</script>
<style>
body {
    overflow: hidden;
    margin: 0;
}

#slider {
    width: 100%;
    height: 100vh;
    position: relative;
}

.slide {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fade-enter-active {
    transition: opacity 1s;
}

.fade-enter {
    opacity: 0;
}

/* GO TO NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
    transition: transform 0.5s ease-in-out;
}

.slide-next-enter {
    transform: translate(100%);
}

.slide-next-leave-to {
    transform: translate(-100%);
}

/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
    transition: transform 0.5s ease-in-out;
}

.slide-prev-enter {
    transform: translate(-100%);
}

.slide-prev-leave-to {
    transform: translate(100%);
}

.updating-slides {
    opacity: .8;
    background-color: #000000;
    padding: 3px 10px;
    border-radius: 10px;
    position: fixed;
    top: 5px;
    left: 8px;
    font-size: 12px;
    font-family: UniviaPro;
    color: #ffffff;
    display: flex;
    justify-content: flex-start;
    gap: 5px;
}

.updating-slides-error {
    background-color: red;
    padding: 3px 10px;
    border-radius: 10px;
    position: fixed;
    top: 5px;
    left: 8px;
    font-size: 12px;
    font-family: UniviaPro;
    color: #ffffff;
    display: flex;
    justify-content: flex-start;
    gap: 5px;
}

.spinner {
    margin-top: 4px;
    display: inline-block;
    width: 6px;
    height: 6px;
    border: 1px solid rgba(255, 255, 255, .3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}
</style>